import { DynamicHeadline } from "components/DynamicHeadline"
import Image from "next/image"
import Section from "../Section"
import styles from "./Team.module.scss"

const Team = ({
  data: {
    dynamic_headline,
    headline_type,
    headline_appearance,
    section_padding_bottom,
    section_padding_top,
    team_row,
  },
  colors,
}) => {
  const hasTeamMembers = team_row.some((tr) => tr.team_members.length > 0)

  return hasTeamMembers ? (
    <Section
      sectionSpacing={{
        top: section_padding_top?.value || null,
        bottom: section_padding_bottom?.value || null,
      }}
      className={styles.section}
      colors={colors}
    >
      {dynamic_headline && (
        <DynamicHeadline
          headlineType={headline_type.value}
          headlineAppearance={headline_appearance.value}
        >
          {dynamic_headline}
        </DynamicHeadline>
      )}
      {team_row.map(
        (tr, index) =>
          tr.team_members?.length > 0 && (
            <div key={index} className={styles.grid}>
              {tr.team_members.map((member, index) => (
                <TeamMember key={index} member={member} />
              ))}
            </div>
          )
      )}
    </Section>
  ) : null
}

const TeamMember = ({ member }) => {
  const imageUrl = member.avatar2?.permalink || member.avatar?.permalink

  if (!imageUrl) return null

  return (
    <div className={styles.card}>
      <div className={styles.imageContainer}>
        <Image
          src={imageUrl}
          alt={member.title}
          layout="fill"
          objectFit="cover"
          className={styles.image}
          sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw"
        />
      </div>
      <div className={styles.info}>
        <p className={styles.name}>{member.title}</p>
        <p className={styles.role}>{member.position}</p>
      </div>
    </div>
  )
}

export default Team
